import { useTheme } from '@components/utils/use-theme'
import Contrast from '@mui/icons-material/Contrast'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'

export const ThemeChangeButton = () => {
  const { theme, setTheme } = useTheme()
  const { t } = useTranslation()

  return (
    <Tooltip
      title={t('layout.header.switch_theme.text', {
        mode: t(theme === 'dark' ? 'layout.header.switch_theme.light' : 'layout.header.switch_theme.dark'),
      })}
    >
      <IconButton
        onClick={() => {
          setTheme(theme === 'dark' ? 'light' : 'dark')
        }}
      >
        <Contrast />
      </IconButton>
    </Tooltip>
  )
}
